// Browser (desktop) alerts for new tickets and customer replies. Off by
// default and per browser: turning it on is a deliberate click that also asks
// the browser for permission. Alerts only fire while the tab is in the
// background; with it open, the in-app indicators already do the job.
const KEY = 'ticket-desktop-notifications';

export const isSupported = () => typeof window !== 'undefined' && 'Notification' in window;

const readPref = () => {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
};

const writePref = (on) => {
  try { localStorage.setItem(KEY, on ? '1' : '0'); } catch { /* preference is best-effort */ }
};

// 'unsupported' | 'blocked' (browser permission denied) | 'on' | 'off'
export const getState = () => {
  if (!isSupported()) return 'unsupported';
  if (Notification.permission === 'denied') return 'blocked';
  return readPref() && Notification.permission === 'granted' ? 'on' : 'off';
};

export const enable = async () => {
  if (!isSupported()) return 'unsupported';
  let permission = Notification.permission;
  if (permission === 'default') permission = await Notification.requestPermission();
  if (permission !== 'granted') return 'blocked';
  writePref(true);
  return 'on';
};

export const disable = () => {
  writePref(false);
  return getState();
};

// Pure: what (if anything) a ticket event should say. Staff's own replies
// carry no `from`, so only customers' replies and new tickets alert.
export const describeEvent = (event, myId = null) => {
  const payload = (event && event.payload) || {};
  if (!payload.ticket_id) return null;
  const subject = payload.subject || 'No subject';
  // Personal alerts: only for the person they are aimed at.
  if (event.type === 'followup-due' || event.type === 'ticket-mention') {
    if (myId === null || Number(payload.user_id) !== Number(myId)) return null;
    return event.type === 'followup-due'
      ? { ticketId: payload.ticket_id, personal: true, title: 'Follow-up due', body: payload.note ? `${subject} - ${payload.note}` : subject }
      : { ticketId: payload.ticket_id, personal: true, title: `${payload.by || 'A colleague'} mentioned you`, body: subject };
  }
  if (event.type === 'ticket-created') {
    const priority = payload.priority && payload.priority !== 'medium' ? `${payload.priority} priority ` : '';
    return { ticketId: payload.ticket_id, title: `New ${priority}ticket`, body: subject };
  }
  if (event.type === 'ticket-activity' && payload.from === 'customer') {
    return { ticketId: payload.ticket_id, title: 'Customer replied', body: subject };
  }
  return null;
};
